import { DatePipe } from '@angular/common';
import { Component, input } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'iw-message',
  styleUrl: './item.component.scss',
  imports: [TranslateModule, DatePipe],
  host: {
    '[class.self]': 'self()',
    '[class.stranger]': '!self()',
  },
  template: `
    <div class="content">
      <span class="text">{{ text() }}</span>
      <time class="timestamp">
        {{ createdAt() | date: 'HH:mm, dd.MM.YY' }}
      </time>
    </div>
  `,
})
export class MessageComponent {
  readonly self = input<boolean>(false);
  readonly text = input<string>();
  readonly createdAt = input<string>();
}
